<template>
  <div class="mobile-appdev-box">
    <div class="mobile-en-title">{{ "APP development".toUpperCase() }}</div>
    <div class="mobile-cn-title">APP开发</div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
